import React,{useState,useEffect} from 'react'
import { LoremIpsum } from 'react-lorem-ipsum';
import shop from '../images/shop.png'
import axios from 'axios'
import {ethers} from 'ethers';
import { provider } from '../contracts/ogContract';
import red_x from '../images/red_x.png'
import "./fadeIn.css";

function RanOutOfVotes(props) {
    let {isOpen,setIsOpen} = props;
  
    return (
        
        < div class={`flex justify-center items-center w-screen  fixed top-24  shadow-lg  duration-150 z-10 text-black ${isOpen==true ? "" : "hidden"} fade-in-image`}>
        
        <div class='bg-slate-100 px-4 py-1 rounded-md  '>
        <img class=' h-4  inline mr-2' src={red_x}/>

            <h1 class='inline'>You've Ran Out Of Votes</h1>

            </div>
            </div>
    )
  }

const DAO = (props) => {
    const[isOpen,setIsOpen] = useState(false);
    const [numVotes,setNumVotes] = useState(0);
    // const [connected,setConnected] = useState(false);
    //const[voteOptions,setVoteOptions] = useState([])
    const{connected,setConnected} = props;
    const{voteOptions,setVoteOptions} = props;

    const[accounts,setAccounts] = useState([])
    const[authorized,notAuthorized] = useState(undefined);
    const[wallet,setWallet] = useState("0x0000000000000000000000000000000000000000")
    //const{wallet,setWallet} = props;
    const sloth_contract_address = "0x1889B8D0860884c3595776419814168D07550Cc1"
    const sloth_abi = ["function balanceOf(address owner) view returns(uint256)"]
    

    const getNumVotes = async () =>{
        try{
            let provider;
            if(window.ethereum) {
            provider = new ethers.providers.Web3Provider(window.ethereum,"any");
            const accounts = await provider.listAccounts();
            if(accounts.length>0){
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/dao/numVotes/${accounts[0]}`)
            const data = res.data
            console.log(data);
            await setNumVotes(data.numVotes)
            console.log(data.numVotes)
            }
            }
            //const res = await axios.get(`${process.env.REACT_APP_API_URL}/dao/numVotes/${wallet}`)
        }
        catch(err){
            console.log(err);
        }
    }

    const voteForOption = async(id,description) => {
        if(!connected){
            return
        }
        if(numVotes<=0){
            setIsOpen(true)
            setTimeout(()=>setIsOpen(false),3000);
            return;
        }
        const provider = new ethers.providers.Web3Provider(window.ethereum,"any");
        const message =  ethers.utils.solidityKeccak256(['uint256','string'],[id,description]);    
        const arrayifyMessage = ethers.utils.arrayify(message)
        const signer = await provider.getSigner();
        const signature = await signer.signMessage(arrayifyMessage);
        const vote = await axios.post(`${process.env.REACT_APP_API_URL}/dao/vote/${id}`,{id,signature})
        console.log(vote.data);
        const status = vote.status
        console.log(status)
        if(status == 201){
            let tempVoteOptions  = [...voteOptions];
            for(let i=0; i<tempVoteOptions.length;i++){
                if(id == tempVoteOptions[i].id){
                    console.log("hi")
                    tempVoteOptions[i].numVotes++;
                    console.log(tempVoteOptions[i]);
                    setVoteOptions(tempVoteOptions);
                    setNumVotes(numVotes-1)
                }

            }
        }
    }

    const maxVote = async(id,description) => {
        if(!connected){
            return
        }
        const provider = new ethers.providers.Web3Provider(window.ethereum,"any");
        const message =  ethers.utils.solidityKeccak256(['uint256','string'],[id,description]);    
        const arrayifyMessage = ethers.utils.arrayify(message)
        const signer = await provider.getSigner();
        const signature = await signer.signMessage(arrayifyMessage);
        const vote = await axios.post(`${process.env.REACT_APP_API_URL}/dao/voteMax/${id}`,{id,signature})
        console.log(vote.data);
        const status = vote.status
        console.log(status)
        if(status == 201){
            let tempVoteOptions  = [...voteOptions];
            for(let i=0; i<tempVoteOptions.length;i++){
                if(id == tempVoteOptions[i].id){
                    console.log("hi")
                    tempVoteOptions[i].numVotes+=numVotes;
                    console.log(tempVoteOptions[i]);
                    setVoteOptions(tempVoteOptions);
                    setNumVotes(0)
                }

            }
        }
    }

    // const getVoteOptions = async () =>{
    //     if(voteOptions.length>0){
    //         console.log("Ran From Memory")
            
    //         return
    //     }

    //     const _voteOptions = await axios.get(`${process.env.REACT_APP_API_URL}/dao/voteOptions`)
    //     setVoteOptions(_voteOptions.data);
    //     console.log("Fetched From API")
        
    //     //console.log('vote options = ',_voteOptions.data)
    //     return;

    // }


    const voting_info = [
        {   
            id:0,
            name: "Option 1",
            description: "word word word word word word word word word word word word word word word",
            numVotes: 3
        },
        {
            id: 1,
            name: "Option 2",
            description: "word word word word word word word word word word word word word word word",
            numVotes: 12
        },
        {
            id: 2,
            name: "Option 3",
            description: "word word word word word word word word word word word word word word word",
            numVotes: 15
        },
        {
            id:3,
            name: "Option 4",
            description: "word word word word word word word word word word word word word word word",
            numVotes: 18
        }
    ]

    
    if(window.ethereum){
        window.ethereum.on('accountsChanged',async (_accounts)=>{
            console.log("heyy")
            await setAccounts(_accounts)
            await setWallet(_accounts[0])
            if(_accounts.length>0){
                await setConnected(true)
                await getNumVotes()
            }
            else{
                await setConnected(false)
            }
        })
    }

    const checkBalance = async () =>{
        try{
            if(window.ethereum){
                const provider = new  ethers.providers.Web3Provider(window.ethereum,"any");
                const accounts = await provider.listAccounts();
                if(accounts.length>0){
                    await setConnected(true)
                    await setWallet(accounts[0])
                    const sloth_contract = new ethers.Contract(sloth_contract_address,sloth_abi,provider);
                    const balanceOf = await sloth_contract.balanceOf(accounts[0])
                    //console.log(parseInt(balanceOf.toString()))
                    
                }
                if(accounts.length<=0){
                    await setConnected(false);
                }
            }
        }
        catch(err){
            console.log(err)
        } 
    }

    async function runOnStartup ()  {
        //getVoteOptions();
        //console.log("get vote options ran")
        checkBalance();
        //console.log("Check Balance Ran")
        getNumVotes();
        //console.log("Num Votes Ran")



    }
    useEffect(()=>{
        runOnStartup()
        
    },[])
  

    
    async function connectWallet(){
        let provider;
        if(window.ethereum){
            provider = new ethers.providers.Web3Provider(window.ethereum,"any");
            
        }
        try{
            await provider.send("eth_requestAccounts", []);
        }
        catch(err){
            console.log(err);
        }
     
      }
  return (
      <>

<RanOutOfVotes isOpen={isOpen} setIsOpen={setIsOpen}/>
<div class=' mx-24 m-auto mt-12  text-justify   max-w-3xl mx-auto'>

            <h1 class='text-4xl pb-3 font-bold text-center'>Sleepy DAO</h1>
            <p>
            One main component of being part of the Sleepy Sloth Society is that you become a stone of the ecosystem. 
As a holder of Sleepy Sloth Society you are part of the global ecosystem. Holders are able to influence : dispersion of funds, direction of the project and more through the DAO decisions.
Each one of your Sleepy Sloth is a vote inside the Sleepy DAO. Based on the number of Sloth that you own you can divide your votes between the options.

            </p>
        </div>


        
    
    {connected && <div class='flex  justify-center mt-8 text-3xl'>
        <h1>Total Votes: {numVotes}</h1>
    </div>}
    {!connected && <div class='flex  justify-center mt-8 text-3xl cursor-pointer'>
        <h1 onClick={()=>connectWallet()}>Please Connect Wallet</h1>
    </div>}
    <div class='grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4  place-items-center gap-16 justify-center mt-12 '>


    
    {voteOptions.map((data)=>{
        return( <div class='card  rounded-2xl outline outline-1  outline-indigo-600 w-60 py-4 text-center'>
        <h1 class='mb-3  font-bold'>{data.name}</h1>
        <p class='mb-3 mx-2'>{data.description}</p>
        {connected && <button onClick={()=>voteForOption(data.id,data.description)} class='bg-slate-600 hover:bg-slate-800 duration-200 rounded-full w-1/2 mb-2 '>Vote</button>}
        <br>
        </br>
        {connected && <button onClick={()=>maxVote(data.id,data.description)} class='bg-indigo-600 hover:bg-indigo-800 duration-200 rounded-full w-1/2 mb-2 '>Vote All</button>}
        {!connected && <button onClick={()=>connectWallet()} class='bg-slate-600 hover:bg-slate-800 duration-200 rounded-full w-1/2 mb-2 '>Connect</button>}

        <p>Votes: {data.numVotes} </p>
    </div>
        )
        
    })}
   
  
   
    </div>

  
 

    </>
  )
}

export default DAO